module.exports = {
  TYPE2: 'type2',
  SCHUKO: 'schuko',
  TYPE1: 'type1',
  CHADEMO: 'chademo',
  TYPE3: 'type3',
  COMBO: 'combo',
};
